fragment QueuedEmailFragmentSparse on EmailQueued {
    id
    status
    deliveryTime
    htmlUrl
    fromUser {
        id
        name
    }
    to {
        avatarEntity {
            id
            name
        }
    }
    subject
    isAlreadySent
    isNextScheduledEmail
}
